import React from "react";
import "./Pagination.css";
import DropDown from "../DropDown/DropDown";
import { GrFormNext } from "react-icons/gr";
import { MdNavigateBefore } from "react-icons/md";
import PropTypes from "prop-types";

const Pagination = ({
  totalPage,
  currentPage,
  paginateHandler,
  setPageSize,
  totalData,
  tableStartIndex,
  tableEndIndex,
  showRowsPerPage = true,
}) => {

  const lastPage = totalPage === 0 ? 1 : totalPage;

  const start = tableStartIndex ?? 0;
  const end = tableEndIndex ?? 0;
  const total = totalData ?? 0;

  const displayText =
    start === end
      ? `${start} of ${total}`
      : `${start}-${end} of ${total}`;

  const paginate = (pageNumber) => {
    if (pageNumber > totalPage || pageNumber <= 0) return;
    paginateHandler && paginateHandler(pageNumber);
  };

  const pageSelect = (size) => {
    setPageSize && setPageSize(size);
  };

  return (
    <div className="Pagination">
      <nav>
        <ul className="pagination justify-content-end m-0 align-items-center">

          {showRowsPerPage && (
            <>
              <li className="page-item page-item-text">
                <span style={{ fontSize: "12px" }}>Rows Per Page</span>
              </li>

              <li className="page-item mx-1">
                <DropDown
                  className="pagination-input--dropdown"
                  inputHandler={(e) => pageSelect(e)}
                  options={[5, 10, 20, 50, 100]}
                />
              </li>
            </>
          )}

          <li className="page-item page-item-text">
            <span>{displayText}</span>
          </li>

          <li className="page-item">
            <button
              className="page-item--icon"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <MdNavigateBefore />
            </button>
          </li>

          <li className="page-item">
            <button
              className="page-item--icon"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === lastPage}
            >
              <GrFormNext />
            </button>
          </li>

        </ul>
      </nav>
    </div>
  );
};

Pagination.propTypes = {
  totalPage: PropTypes.number,
  currentPage: PropTypes.number,
  paginateHandler: PropTypes.func,
  setPageSize: PropTypes.func,
  totalData: PropTypes.number,
  tableStartIndex: PropTypes.number,
  tableEndIndex: PropTypes.number,
  showRowsPerPage: PropTypes.bool,
};

export default Pagination;